//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'UrineOutput',
  data() {
    return {
      defaultJson:{
        "Weight": "体重",
        "Urine Output": "尿量",
        "in": "收集时间",
        "Oliguria": "少尿",
        "Amount of Urine": "总尿量",
        "Fluid Intake":'液体摄入'
      },
      form:{
        weight:'',
        urine:'',
        time:'',
        intake:'',
      },
      res2:'--',
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        self.res2 ='--'
        return '--'
      } else {
        // urine/weight/time
        let result = form.urine/form.weight/form.time
        // intake-urine
        self.res2 = (form.intake-form.urine).toFixed(0)

        self.hasScore = true
        return String(result.toFixed(1))
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/UrineOutput.vue